const { Keywords } = require('../core/keywords');

/**
 * Supported Escape Characters:
 * \n - Newline
 * \t - Tab
 * \r - Carriage Return
 * \" - Double Quote
 * \' - Single Quote
 * \\ - Backslash
 */

module.exports = {
    [Keywords.PROGRAM_START]: 'শুরু',
    [Keywords.PROGRAM_END]: 'শেষ',
    [Keywords.PRINT]: 'বলো',
    [Keywords.VARIABLE]: 'ধরি',
    [Keywords.UNTIL]: 'যতক্ষণ',
    [Keywords.IF]: 'যদি',
    [Keywords.ELSE]: 'নাহলে',
    [Keywords.FOR]: 'চক্র',
    [Keywords.BREAK]: 'থামো',
    [Keywords.CONTINUE]: 'চলবে',
    [Keywords.TRUE]: 'সত্য',
    [Keywords.FALSE]: 'মিথ্যা',
    [Keywords.AND]: 'এবং',
    [Keywords.OR]: 'অথবা',
    [Keywords.LENGTH]: 'দৈর্ঘ্য',
    [Keywords.INPUT]: 'জিজ্ঞাসা করো {{name}}'
};
